<template>
	<div class="templates">
		<form>
		<md-field class="md-field-margin">
			<label>Template Name:</label>
			<md-input v-model="template.name" name="name" v-validate="'required|max:60'" @blur="template.name = sanitizeInput($event.target.value || template.name)"></md-input>
		</md-field>
		<p v-show="errors.has('name')" v-text="errors.first('name')" class="error"></p>
		<md-field class="md-field-margin">
			<label>Description:</label>
			<md-input v-model="template.description" name="description" v-validate="'required|max:100'" @blur="template.description = sanitizeInput($event.target.value || template.description)"></md-input>
		</md-field>
			<p class="error" v-show="errors.has('description')" v-text="errors.first('description')"></p>
		<md-field class="md-field-margin">
			<label>Body:</label>
			<md-textarea v-model="template.body" name="body" v-validate="'required'" @blur="template.body = sanitizeInput($event.target.value || template.body)"></md-textarea>
		</md-field>
			<p class="error" v-show="errors.has('body')" v-text="errors.first('body')"></p>
		<md-field class="md-field-margin">
			<label>Email Category:</label>
			<md-select v-model="template.category" name="category"  v-validate="'required'" placeholder="Email Category" id="category">
				<md-option value="None">None (no category)</md-option>
				<md-option value="noFollowUp">No Follow Up</md-option>
			</md-select>
		</md-field>
			<p class="error" v-show="errors.has('category')" v-text="errors.first('category')"></p>
		<md-field class="md-field-margin">
			<!-- <md-button class="md-raised md-round md-accent" @click="save" :disabled="this.errors.any()">{{ saveText }}</md-button> -->
			<md-button class="md-raised md-round md-accent" @click="save">{{ saveText }}</md-button>
		</md-field>
		</form>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import { sanitizeInput } from "../utils/sanitizer";
export default {
  data() {
    return {
      api: new API(),
      saveText: "save",
      template: {
	      name: '',
	      description: '',
	      body: ''
      }
    };
  },
  methods: {
	sanitizeInput(input) {
      return sanitizeInput(input);
    },
    loadData: async function() {
      await this.api.get(`sms-templates/${this.template_id}`).then(template => {
        this.template = template.data;
      });
    },
    save: async function() {
	    this.$validator.validateAll().then((result) => {
        if (result) {
          // Sanitize all fields one final time before saving
          const sanitizedTemplate = {
            name: this.sanitizeInput(this.template.name),
            description: this.sanitizeInput(this.template.description),
            body: this.sanitizeInput(this.template.body),
            category: this.template.category // No need to sanitize as it's from select
          };

          this.api.post('sms-templates', sanitizedTemplate).then(template => {
            this.$emit("reload");
            this.$router.push('/');
          }).catch(err => {
            return new Promise((resolve, reject) => {
              resolve(err);
              if (err.response.status === 500) {
                this.errors.add({field: 'name', msg: err.response.data.message});
              }
            });
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CreateSmsTemplate.vue